import { connect } from 'react-redux';
import React from 'react';

import ReactWebChat from './WebChat';

class App extends React.Component {
  render() {
    const {
      props: { dispatch }
    } = this;

    //return (<div id="app"></div>);

    return (
      <div id="app">
      </div>
    );

    // return (
    //   <div id="app">
    //     <div class="chatbot-header">
    //       <span class="logo"></span>
    //     </div>
    //     <ReactWebChat appDispatch={dispatch} />
    //   </div>
    // );
  }
}

export default connect()(App);
